import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import _ from 'lodash';
import {
  ReflexContainer,
  ReflexSplitter,
  ReflexElement,
} from 'react-reflex';
import 'react-reflex/styles.css';
import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@material-ui/core';
import AreaDisplay from './area';
import Constants from '../../common/constants';
import { IsEmpty } from '../../common/checks';
import apiService from '../../services.js/apiService';

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading:      false,
      areas:        [],
      selectedArea: null,
      createAction: null,
      searchName:   '',
      searchType:   '',
    };
    this.setArea = this.setArea.bind(this);
    this.createArea = this.createArea.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSearchType = this.handleSearchType.bind(this);
  }

  componentDidMount() {
    this.getAreas();
  }

  async getAreas() {
    try {
      const areas = await apiService.getAreas();
      this.setState({ areas: _.sortBy(areas, 'name') });
      this.setState({ loading: false });
    } catch (error) {
      toast.error(error);
    }
  }

  refreshList() {
    this.setState({ loading: true }, () => {
      this.setState({ selectedArea: null, createAction: null });
      this.getAreas();
    });
  }

  setArea(data) {
    this.setState({ selectedArea: data, createAction: false });
  }

  createArea() {
    this.getAreas();
    this.setState({ selectedArea: null, createAction: true });
  }

  handleSearchChange = _.debounce((value) => {
    this.setState({ searchName: value });
  }, 500)

  handleSearchType = _.debounce((value) => {
    this.setState({ searchType: value });
  }, 500)

  onChange(e) {
    this.handleSearchChange(e.target.value);
  }

  render() {
    const { selectedArea, createAction } = this.state;
    let filteredAreas =       this.state.areas.filter((area) => area.name.toLowerCase().includes(this.state.searchName.toLocaleLowerCase()));

    if (!IsEmpty(this.state.searchType)) {
      filteredAreas = filteredAreas.filter((area) => area.type === this.state.searchType);
    }

    let districts = _.filter(this.state.areas, (a) => a.type === Constants.AreaType.District);
    // In case there is area selected, we are not include it to the result
    if (!IsEmpty(selectedArea)) {
      districts = _.filter(districts, (a) => a.name !== selectedArea.name);
    }

    const districtsCoords = _.map(districts, 'coords');

    return (
      <>
        <ReflexContainer orientation="vertical">
          <ReflexElement
            className="left-pane"
            minSize="200"
            maxSize="400"
            style={{ overflowX: 'hidden' }}
          >
            <div className="pane-content p-3">

              <Button variant="outlined" color="secondary" className="mb-3" onClick={() => { this.createArea(); }}>Add new Area</Button>

              <div className="form-group row mb-5">
                <div className="col-md-6">
                  <TextField name="search" label="Search Area" className="form-control" defaultValue={this.state.searchName || ''} multiline onChange={(e) => this.onChange(e)} />
                </div>
                <div className="col-md-6">
                  <FormControl variant="standard" style={{ width: '100%' }}>
                    <InputLabel id="demo-simple-select-standard-label" className="col-form-label d-block">Type</InputLabel>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      value={this.state.searchType}
                      onChange={(e) => this.handleSearchType(e.target.value)}
                      label="Type"
                    >
                      <MenuItem value="">All</MenuItem>
                      <MenuItem value={Constants.AreaType.Street}>{Constants.AreaType.Street}</MenuItem>
                      <MenuItem value={Constants.AreaType.District}>{Constants.AreaType.District}</MenuItem>
                      <MenuItem value={Constants.AreaType.SubDistrict}>{Constants.AreaType.SubDistrict}</MenuItem>
                      <MenuItem value={Constants.AreaType.MRT}>{Constants.AreaType.MRT}</MenuItem>
                      <MenuItem value={Constants.AreaType.Region}>{Constants.AreaType.Region}</MenuItem>
                      <MenuItem value={Constants.AreaType.Province}>{Constants.AreaType.Province}</MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>

              <div style={{ overflow: 'hidden auto', maxHeight: '100vh' }}>
                { this.state.areas.length > 0 ? (
                  <ul className="list-group list-group-flush">
                    {!this.state.loading
                    && _.map(filteredAreas, (area) => (
                      <li key={area.id} className="list-group-item">
                        <span
                          aria-hidden="true"
                          onClick={() => { this.setArea(area); }}
                          style={{
                            cursor:         'pointer',
                            fontSize:       16,
                            display:        'block',
                            color:          '#000000',
                            textDecoration: 'none',
                            fontWeight:     'bold',
                          }}
                        >
                          {area.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                ) : 'No Areas listed. Add one' }
              </div>
            </div>
          </ReflexElement>

          <ReflexSplitter style={{ background: 'rgb(235 235 235)', width: 5, height: 'auto', minHeight: '100vh', maxHeight: 'auto' }} />

          <ReflexElement className="right-pane">
            <div className="pane-content p-3">
              { !selectedArea && createAction === null ? <h1>Select an Area</h1>
                : !this.state.loading
                  && (
                    <AreaDisplay
                      key={selectedArea}
                      createAction={createAction}
                      area={selectedArea}
                      districtsCoords={districtsCoords}
                      updateList={() => this.refreshList()}
                    />
                  ) }
            </div>
          </ReflexElement>
        </ReflexContainer>
      </>
    );
  }
}

Details.propTypes = {
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(null, mapDispatchToProps)(Details);
